import BaseApi from './BaseApi'
import {exception} from '../../util/decorators'

export default class CategoryApi extends BaseApi {
  @exception('获取推荐列表失败')
  getRecommendations () {
    return this.httpJsonp('/misc/indexCategory')
  }

  @exception('获取分类列表失败')
  getPage (params) {
    return this.httpJsonp('/category/index', params)
  }

  @exception('获取牧者专栏失败')
  getMZZL () {
    return this.httpJsonp('/category/mzzl')
  }

  @exception('获取全部分类列表失败')
  getAll () {
    return this.httpJsonp('/category/all')
  }

  @exception('获取圣经目录失败')
  getBible () {
    return this.httpJsonp('/category/bible')
  }
}



// WEBPACK FOOTER //
// ./src/service/api/CategoryApi.js